import styles from "./serverMegamPage.module.scss";
import { useRef, useState, useEffect } from "react";

export default function ServerMegamPage() {

  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (MyRef.current) observer.observe(MyRef.current);

    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, [MyRef, visible]);

  const [open, setOpen] = useState(0);
  const openLogic = (index) => {
    setOpen(() => (open === index ? null : index));
  };
  const obj = [
    {
      title: "What is Megam and how does it work?",
      content:
        "Megam is a comprehensive finance app designed to help you manage your money effectively. It allows you to track expenses, create budgets, set financial goals, and monitor investments all in one place. By syncing with your bank accounts credit cards, Savi provides real-time insights into your financial health.",
    },
    {
      title: "Is Kriha Megam secure?",
      content:
        "Megam is a comprehensive finance app designed to help you manage your money effectively. It allows you to track expenses, create budgets, set financial goals, and monitor investments all in one place. By syncing with your bank accounts credit cards, Savi provides real-time insights into your financial health.",
    },
    {
      title: "How can I get started with Megam?",
      content:
        "Megam is a comprehensive finance app designed to help you manage your money effectively. It allows you to track expenses, create budgets, set financial goals, and monitor investments all in one place. By syncing with your bank accounts credit cards, Savi provides real-time insights into your financial health.",
    },
    {
      title: "What devices and platforms does Megam support?",
      content:
        "Megam is a comprehensive finance app designed to help you manage your money effectively. It allows you to track expenses, create budgets, set financial goals, and monitor investments all in one place. By syncing with your bank accounts credit cards, Savi provides real-time insights into your financial health.",
    },
    {
      title: "What are the fees in Megam?",
      content:
        "Megam is a comprehensive finance app designed to help you manage your money effectively. It allows you to track expenses, create budgets, set financial goals, and monitor investments all in one place. By syncing with your bank accounts credit cards, Savi provides real-time insights into your financial health.",
    },
  ];

  
  return (
    <div className={styles.container} ref={MyRef}>
      <div className={styles.wrapper}>
        <div className={styles.wrapperContainer}></div>
        <div className={styles.left}>
          <div className={styles.leftTop}>
            <h1>Frequently Asked Question</h1>
            <div className={styles.leftSubTitle}>
              Organize your finances with WealthTrack. Follow your spending,
              save prudently in an easy-to-navigate app.
            </div>
          </div>

          <div className={visible ? styles.leftImg : styles.leftImgAction}>
            <img
              src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/FAQ_SECTION/fAQSectionServerImage.png"
              alt="img"
              className={styles.serverImg}
            />
          </div>
        </div>
        <div
          className={styles.right}
          ref={MyRef}
        >
          {obj.map((item, index) => (
            <div
              className={
                open === index
                  ? styles.rightContainerAction
                  : styles.rightContainer
              } 
              onClick={() => openLogic(index)}
              key={index}
            >
              <div>
                <img
                  className={styles.plusimg}
                  src={
                    open === index
                      ? "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/FAQ_SECTION/fAQMinusAsset.png"
                      : "https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/FAQ_SECTION/fAQPlusAsset.png"
                  }
                  alt="img"
                />
              </div>
              <div>
                <div className={styles.plusTitle}>
                  <div className={styles.title}>{item.title}</div>
                  {open === index && <div className={styles.content}>{item.content}</div>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <div className={styles.bottomImg}>
          <img
            className={styles.bottomImgCenter}
            src="https://krihaportfolio.s3.ap-south-1.amazonaws.com/KRIHA_MEGAM/FOOTER_SECTION/lightBright.png"
            alt="img"
          />
        </div>
      </div>
    </div>
  );
}
